var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeadphones02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 11.3333V8.66667C14.6666 4.98477 11.6819 2 7.99998 2C4.31808 2 1.33331 4.98477 1.33331 8.66667V11.3333M4.99998 14C4.0795 14 3.33331 13.2538 3.33331 12.3333V10.3333C3.33331 9.41286 4.0795 8.66667 4.99998 8.66667C5.92045 8.66667 6.66665 9.41286 6.66665 10.3333V12.3333C6.66665 13.2538 5.92045 14 4.99998 14ZM11 14C10.0795 14 9.33331 13.2538 9.33331 12.3333V10.3333C9.33331 9.41286 10.0795 8.66667 11 8.66667C11.9205 8.66667 12.6666 9.41286 12.6666 10.3333V12.3333C12.6666 13.2538 11.9205 14 11 14Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones02);
export default __webpack_public_path__ + "static/media/headphones-02.a385b8ac930357e012bed963ff67a8f3.svg";
export { ForwardRef as ReactComponent };